import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"
import useLocalStorage from "use-local-storage"
import { graphql, useStaticQuery } from "gatsby"
export const FiverButton = () => {
  // state for local storage
  const [storeFiverLink, setStoreFiverLink] = useLocalStorage<string>(
    "link",
    ""
  )
  // getting data from sanity graphql
  const fiverData = useStaticQuery(graphql`
    query {
      sanitySiteSettings {
        fiverLink
      }
    }
  `)
  // getting url from deep objects
  const fiverUrl: any = fiverData?.sanitySiteSettings?.fiverLink
  // storing fiver link if !exist and if exist than get from localStore
  const storeLink = () => {
    if (!storeFiverLink) {
      setStoreFiverLink(fiverUrl)
    }
  }
  storeLink()
  return (
    <div className="hidden">
      <div className="flex gap-5 items-center">
        {/* ===============  hiding button on the basis of fiverLink ================= */}
        {fiverUrl && (
          <a href={`${storeFiverLink}`} target="_black">
            <button className="flex items-center lg:gap-2 gap-1 lg:px-3 whitespace-nowrap px-2 lg:py-3 py-2 text-black font-inter text-sm lg:font-semibold shadow-3x hover:opacity-70  rounded-lg bg-btn bg-header-unique-btn">
              Find Us On Fiver
              <StaticImage
                placeholder="blurred"
                className="lg:w-8 w-4"
                src="./fiverr-icon.png"
                alt="fiverr"
              />
            </button>
          </a>
        )}
      </div>
    </div>
  )
}
